import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Banche } from 'my-lib-sanfelici/my-lib-sanfelici';
import { BancheService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-banche-list',
  templateUrl: './banche-list.component.html',
  styleUrls: ['./banche-list.component.css']
})
export class BancheListComponent implements OnInit {
banche: Observable<Banche[]>;
  constructor(
    private router: Router,
    private bancheservice: BancheService,

  ) { }
ondelete(id) {
  this.bancheservice.delete(id);
}
  ngOnInit() {
this.banche = this.bancheservice.list();

  }

}
